import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { Form, FormGroup } from 'reactstrap';
import { Label } from 'reactstrap';
import { Button } from 'reactstrap';
import withNavigateHook from '../../myRoutes';
import { useLocation } from 'react-router-dom';

import DatePicker, { CalendarContainer } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class Other extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            gender: "",
            firstname: "",
            lastname: "",
            dateofbirth: new Date(),
        }
    }


    // location = useLocation();
    // currentPath = this.props.location.state;
    //location.state;

    componentDidMount = () => {
        console.log(this.props.location)
    }


    render() {
        return (
            <div className='mainDivHome'>
                <div style={{ paddingTop: "10px" }}>
                    <span style={{ fontStyle: "italic" }}><label>Welcome To th OTHER Page...</label></span>
                    {/* <span style={{ fontStyle: "italic" }}><label>, today is {this.state.date}</label></span> */}
                    {/* <span><label>{JSON.stringify(this.query)}</label></span> */}
                </div>
                <div>
                    <Form>
                        {/* <label style={{ marginRight: "5px" }}>
                            Date of birth
                        </label> */}
                        
                            <CalendarContainer>
                                <DatePicker 
                                    selected={this.state.dateofbirth}
                                    showMonthDropdown
                                    showYearDropdown
                                // onChange={(date) => this.handleDateOfBirthChange(date)}
                                />
                            </CalendarContainer>                   

                    </Form>
                </div>
            </div>
        );
    }
}

export default withNavigateHook(Other);